import { APP_VERSION, COUNTRY_CODE, EnvironmentType } from "./environment.type";

export const environment: EnvironmentType = {
  placement: "prod",
  production: true,
  route_hash: false,
  timezone: "America/Montevideo",
  code: COUNTRY_CODE.uy,
  currency: "UYU",
  grammar: "es",
  lang: "es",
  phone_length: 9,
  max_tip: 2000,
  phone_prefix: "+598",
  gateway: {
    base_url: "https://services.rappi.com.uy",
    gateway_prefix: "/api/cargo-api-gateway/portal/",
    csv_prefix: "/api/cargo-api-gateway/csv/portal/",
    location_gateway_prefix: "/api/cargo-api-gateway/core-maps/address/",
    settlement_prefix: "/api/cargo-api-gateway/portal/settlement/",
  },
  logoUrl: "https://cargo-core-api.s3.us-west-2.amazonaws.com/uy/cargo-logos/",
  trackingUrl: "cargo-tracking.rappi.com.uy/",
  maps_api: {
    api_key: "AIzaSyA9w0iZyex3UGAYS-w0oJ_dKzbsrhBm9YA",
  },
  coordsCenter: { lat: -34.90328, lng: -56.18816 },
  currencySymbol: "$U",
  decimalPattern: /^[0-9]+([.]\d{0,1})?$/,
  decimalNumber: 1,
  country: {
    defaultLocale: "es-UY",
  },
  localeUrl: "https://cargo-core-api.s3.amazonaws.com/uy/cargo-logos/",
  auth0: {
    client_id: "hDcAOaY9heMYiAxYPvr5Ynt3ZeNybA43",
    client_secret: "OxnMGuC8OXHjYTgznaaKL2ItdOB4xdMj2jpTDbx6au00NQX47lBEdjgGXc6ia2m4",
    domain: "https://login.partners.rappi.com",
  },
  amplitude: {
    key: "032f00f0dfdad881e7391f28f35156f6",
  },
  OAuthGateway: "https://www.rappi.com.uy/login-legacy/signup",
  i18n_version: APP_VERSION,
  kustomer_assistant_id: "664bbe3419e7a2316b52dc7a",
};
